import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CompanyContactData } from '@pxtra-client-lib-legacy/gen';
import { DataGrid, DataGridElement } from '../../../../lib/components/compound/dataGrid';

interface Props {
  data?: CompanyContactData;
}

export const ContactDataView: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  return (
    <DataGrid>
      <DataGridElement title={t('employee:FIRST_NAME')} value={data?.first_name} />
      <DataGridElement title={t('employee:LAST_NAME')} value={data?.last_name} />
      <DataGridElement title={t('auth:email')} value={data?.email} />
      <DataGridElement title={t('company:TELEPHONE')} value={data?.phone} />
    </DataGrid>
  );
};
